import { pushCookiePolicyEvent } from './analytics';

const getConsentStatusName = value => (value ? 'granted' : 'denied');

const waitForScript = (scriptName, callback, maxAttempts = 50, attempt = 1) => {
  if (window[scriptName] && typeof window[scriptName] === 'function') {
    callback();
  } else if (attempt < maxAttempts) {
    setTimeout(() => waitForScript(scriptName, callback, maxAttempts, attempt + 1), 100);
  }
};

const updateClarityConsent = consentData => {
  if (!consentData) return;

  waitForScript('clarity', () => {
    window.clarity('consentv2', {
      ad_Storage: getConsentStatusName(consentData.ad_storage),
      analytics_Storage: getConsentStatusName(consentData.analytics_storage),
    });
  });
};

const updateGtagConsent = consentData => {
  const adStatus = getConsentStatusName(consentData.ad_storage);

  waitForScript('gtag', () => {
    window.gtag('consent', 'update', {
      ad_storage: adStatus,
      ad_user_data: adStatus,
      ad_personalization: adStatus,
      analytics_storage: getConsentStatusName(consentData.analytics_storage),
    });
  });
};

export const updateConsentStatus = consent => {
  if (consent) {
    updateGtagConsent(consent);
    updateClarityConsent(consent);
  }
  pushCookiePolicyEvent();
};
